// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@bg/Overrides/Widgets/Brand/BrandList";
import { xScreen } from "@bg/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles.backToTopButton = {
    variant: "tertiary",
    sizeVariant: "large",
    css: css`
        position: absolute;
        box-shadow: 0 0 25px 0 rgba(79, 79, 119, 0.18);
        height: 40px;
        width: 190px;
        padding-right: 8px !important;
        padding-left: 8px !important;
        top: 0;
        left: 30px;
        z-index: 100;
        svg {
            fill: ${getColor("text.main")};
        }
        span {
            text-transform: capitalize;
            line-height: 16px;
        }
        &:hover svg {
            fill: ${getColor("common.white")};
        }
        ${xScreen("lte", "sm")} {
            position: static;
        }
    `,
};
